export class AutomatSim {
 
    _id?: string;

    setID(id) {
        this._id = id;
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/automatSim.ts